import * as React from "react";
export /**
 * @license lucide-react v1.47.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

const ContactModalContext = React.createContext(undefined);
export const ContactModalProvider = ({ children }) => {
  const [t, n] = React.useState(false);
  const [r, i] = React.useState(null);
  return (
    <ContactModalContext.Provider
      value={{
        isOpen: t,
        inquiry: r,
        openModal: () => {
          i(null);
          n(true);
        },
        openInquiry: (o, s = "Request a Quote") => {
          i({
            product: o,
            intent: s,
          });
          n(true);
        },
        closeModal: () => n(false),
      }}
    >
      {children}
    </ContactModalContext.Provider>
  );
};
export const useContactModal = () => {
  const e = React.useContext(ContactModalContext);
  if (!e) {
    throw new Error("useContactModal must be used within ContactModalProvider");
  }
  return e;
};
